import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { pervyyDostupnyyRazdel, razdelPoAdresu } from '../../components/layout/menyuAdminki';
import { OtkazVDostupe } from './OtkazVDostupe';
import { OTKAZ_PODPIS, OTKAZ_ZAGOLOVOK } from './otkaz';
import { usePermissions } from './usePermissions';
import { useAuth } from './useAuth';

interface Props {
  children: ReactNode;
}

/**
 * ⛔ СКРЫТЫЙ РАЗДЕЛ НЕ ОТКРЫВАЕТСЯ И ПРЯМОЙ ССЫЛКОЙ (владелец, 07.09.2026, `prv3`).
 *
 * Дословно владелец: «Скрытый раздел: пропадает из меню И закрыт роутом/API-гейтом —
 * прятать только пункт меню запрещено, это дыра».
 *
 * Обёртка стоит ОДНА на всё дерево маршрутов, внутри `RequireAuth`. Руками разметить
 * 104 маршрута значило бы завести 104 места, где можно забыть, — а забытый маршрут и
 * есть та самая дыра. Адрес сопоставляется с разделом по самому длинному совпавшему
 * пути, поэтому `/clients/duplicates` закрывается «Дублями», а не «Клиентками».
 *
 * ⛔ Отказ ОБЪЯСНЯЕТСЯ словами, а не уводит молча на другую страницу: молчаливый редирект
 * уже признан багом на `s203` — человек не понимает, что произошло, и идёт спрашивать.
 *
 * Настоящий замок — на сервере (`ZakrytyRazdel`): здесь мы бережём человека от пустого
 * экрана, а не полагаемся на фронт как на защиту.
 */
export function RequireVidimost({ children }: Props) {
  const { isLoading } = useAuth();
  const { can, isSuperAdmin, sectionHidden } = usePermissions();
  const location = useLocation();

  if (isLoading) {
    return <>{children}</>;
  }

  const razdel = razdelPoAdresu(location.pathname);

  if (razdel && sectionHidden(razdel)) {
    return (
      /* ⛔ ТО ЖЕ СЛОВО, ЧТО У ГЕЙТА ПРАВА (`s406`, В-14). Прежний текст сообщал
         «права у вас при этом не отбирали» — то есть рассказывал постороннему,
         как устроена настройка чужого доступа. Разница «нет права / спрятан
         настройкой» существует и живёт в следе, где её читает тот, кому она
         нужна; упёршемуся в стену идти всё равно к владельцу. */
      <OtkazVDostupe zagolovok={OTKAZ_ZAGOLOVOK} kuda={pervyyDostupnyyRazdel(can, isSuperAdmin, sectionHidden)}>
        {OTKAZ_PODPIS}
      </OtkazVDostupe>
    );
  }

  return <>{children}</>;
}
